import axios from "axios"
export function getCampaignDetails(token, advertismentId) {
    return axios.get(process.env.REACT_APP_API_URL + `/getCampaignDetails?advertismentId=${advertismentId}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}